import React, { useContext, useEffect, useState } from "react";
import StatusModal from "./StatusModal";
import { AlertContext } from "../context/MainContext";

const Alert = () => {
  const { alert, setAlert } = useContext(AlertContext); // Alert is set to string values of the appropriate action it is alerting for
  const [countdown, setCountdown] = useState(5);

  const variant = alert?.[2]; // 'confirm' | 'waiting' | 'failed'

  useEffect(() => {
    if (alert) {
      if (variant === "waiting") {
        // Keep processing modal open until explicitly cleared
        setCountdown(null);
        return undefined;
      }

      setCountdown(5); // Reset countdown when alert appears

      // Countdown timer that updates every second
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setAlert(null);
      }, 5000);

      return () => {
        clearTimeout(timer);
        clearInterval(countdownInterval);
      };
    }
  }, [alert, setAlert]);

  if (!alert) return null;
  const countdownText =
    variant === "waiting" || countdown == null
      ? null
      : `Closing in ${countdown} second${countdown !== 1 ? "s" : ""}...`;
  return (
    <StatusModal
      variant={variant}
      title={alert[0]}
      message={alert[1]}
      countdownText={countdownText}
      onClose={() => setAlert(null)}
    />
  );
};

export default Alert;
